export default __webpack_public_path__ + "images/0ca4dbe0978e6af28e421c43cb946294-sydney_desktop.webp";